import React, { ReactElement } from 'react';
import { Button } from 'antd';
import { FallbackProps } from 'react-error-boundary';

import BaseLayout from 'shared/baseLayout/BaseLayout';

import './ErrorFallback.scss';

function ErrorFallback({
  error,
  resetErrorBoundary,
}: FallbackProps): ReactElement {
  return (
    <BaseLayout>
      <div className="ErrorFallback">
        <h3 className="ErrorFallback__title">Something went wrong:</h3>
        <p className="ErrorFallback__message">
          <pre>{error.message}</pre>
          <Button onClick={resetErrorBoundary} type={'link'}>
            Redirect to home
          </Button>
        </p>
      </div>
    </BaseLayout>
  );
}

export default ErrorFallback;
